import React, { memo } from 'react';
import { TableCell, TableRow } from '@mui/material';
import PropTypes from 'prop-types';
import { TableControls } from '../../../../BaseEditor';

function Row({
  row, fields, actions, readOnly, active, errors,
}) {
  return (
    <TableRow
      key={row.id}
      onClick={(e) => actions.onActivateRow(e, row.id)}
      selected={active}
      hover
    >
      <TableCell>
        <TableControls.DateInput
          value={row.datefrom}
          onChange={(e, v) => actions.onChange(e, row.id, { datefrom: v })}
          readOnly={fields.datefrom.read_only || readOnly}
          errors={errors && errors.datefrom}
        />
      </TableCell>
      <TableCell>
        <TableControls.NumerInput
          value={row.value}
          precision={2}
          onChange={(e, v) => actions.onChange(e, row.id, { value: v })}
          readOnly={fields.value.read_only || readOnly}
          errors={errors && errors.value}
        />
      </TableCell>
      <TableCell>
        <TableControls.Selector
          value={row.info_source}
          precision={2}
          onChange={(e, v) => actions.onChange(e, row.id, { info_source: v })}
          readOnly={fields.info_source.read_only || readOnly}
          values={fields.info_source.choices}
          errors={errors && errors.info_source}
        />
      </TableCell>
      <TableCell>
        <TableControls.StringInput
          value={row.comment}
          onChange={(e, v) => actions.onChange(e, row.id, { comment: v })}
          readOnly={fields.comment.read_only || readOnly}
          errors={errors && errors.comment}
        />
      </TableCell>
    </TableRow>
  );
}

Row.propTypes = {
  row: PropTypes.shape({
    id: PropTypes.number,
    datefrom: PropTypes.string,
    dateto: PropTypes.string,
    value: PropTypes.number,
    info_source: PropTypes.number,
    comment: PropTypes.string,
  }).isRequired,
  fields: PropTypes.shape({
    datefrom: PropTypes.shape({ read_only: PropTypes.bool }),
    dateto: PropTypes.shape({ read_only: PropTypes.bool }),
    value: PropTypes.shape({ read_only: PropTypes.bool }),
    info_source: PropTypes.shape({
      read_only: PropTypes.bool,
      choices: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.number,
        display_name: PropTypes.string,
      })),
    }),
    comment: PropTypes.shape({ read_only: PropTypes.bool }),
  }).isRequired,
  actions: PropTypes.shape({
    onChange: PropTypes.func.isRequired,
    onActivateRow: PropTypes.func.isRequired,
  }).isRequired,
  readOnly: PropTypes.bool,
  active: PropTypes.bool,
  errors: PropTypes.shape({
    datefrom: PropTypes.arrayOf(PropTypes.string),
    value: PropTypes.arrayOf(PropTypes.string),
    info_source: PropTypes.arrayOf(PropTypes.string),
    comment: PropTypes.arrayOf(PropTypes.string),
  }),
};

Row.defaultProps = {
  readOnly: false,
  active: false,
  errors: null,
};

export default memo(Row);
